import { useEffect, useState } from "react";
import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from "react-places-autocomplete";
import { GoogleApiWrapper } from "google-maps-react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { getCategory, getSubcategory } from "../../../redux/actions";
import "./searchForm.css";
import useGeolocation from 'react-hook-geolocation';

const SearchForm = () => {


    const geolocation = useGeolocation();
    const [title, setTitle] = useState();
    const [categoryId, setCategoryId] = useState();
    const [subCategoryId, setSubCategoryId] = useState();
    const [location, setLocation] = useState();
    const [distance, setDistance] = useState();

    const [lng, setlng] = useState()
    const [lat, setlat] = useState()

    const [address, setAddress] = useState();
    const [queryparam, setQueryParam] = useState("")
    const dispatch = useDispatch();
    const history = useHistory();
    const loc = useLocation();
    const [subCategoryOptions, setSubCategoryOptions] = useState();

    useEffect(() => {
        dispatch(getCategory());
        dispatch(getSubcategory())
    }, [])

    useEffect(() => {
        if (categoryId) {
            const options = subCategories.filter(subCat => subCat.categoryId == categoryId);
            setSubCategoryOptions(options)
        }
        else {
            setSubCategoryId(null);
            setSubCategoryOptions(null);
        }
    }, [categoryId])

    useEffect(() => {
        if (!address)
            setLocation(null)
    }, [address])

    useEffect(() => {
        if (!geolocation.error) {
            setlng(geolocation.longitude)
            setlat(geolocation.latitude)

        }

    }, [geolocation])



    const handleSelect = async (value) => {
        const results = await geocodeByAddress(value);
        const result = results[0];
        const addressComponents = result.address_components;
        for (let i = 0; i < addressComponents.length; i++) {
            let component = addressComponents[i];
            if (component.types.indexOf('locality') !== -1) {
                setLocation(component.long_name);
                break;
            }
        }
        const latLng = await getLatLng(result);
        console.log("latLng is: ", latLng);
        // setQueryParam(`${queryparam}location=${location}&`)
        setAddress(value);
    }

    const categories = useSelector(state => state.categoryDetail.categories);
    const subCategories = useSelector(state => state.subCategoryDetail.subCategories);

    return (
        <section className="search-form-holder">
            <div className="container">
                <div className="form-wrapper">
                    <h3>Search what you are looking for.
                        {/* {!geolocation.error
    ? (
      <ul>
        <li>Latitude:          {geolocation.latitude}</li>
        <li>Longitude:         {geolocation.longitude}</li>
        <li>Location accuracy: {geolocation.accuracy}</li>
        <li>Altitude:          {geolocation.altitude}</li>
        <li>Altitude accuracy: {geolocation.altitudeAccuracy}</li>
        <li>Heading:           {geolocation.heading}</li>
        <li>Speed:             {geolocation.speed}</li>
        <li>Timestamp:         {geolocation.timestamp}</li>
      </ul>
    )
    : (
      <p>No geolocation, sorry.</p>
    )} */}
                    </h3>
                    <form className="search-form d-flex align-items-center justify-content-between" action="" method="post">
                        <div className="form-group full-w applyPd">
                            <input type="text" className="form-control field-des" placeholder="Search 2172 items" onChange={(event) => {
                                setTitle(event.target.value);
                                // setQueryParam(`${queryparam}title=${event.target.value}&`)
                            }} />
                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/category.png").default} className="img-fluid" />
                            </span>
                            <select id="categories" name="categories" className="field-des " form="categoriesform" onChange={(event) => {
                                const value = event.target.value;
                                setCategoryId(value !== "All" ? value : null);
                            }}>
                                <option value="All">All categories</option>
                                {categories && categories.map((category, index) => <option key={index} value={category._id}>{category.name}</option>)}
                            </select>
                            {/* <Select id="color"
										value={option1}
										onChange={() => handleChange1()}
										classNamePrefix="ls-select-home"
										options={CategoryOptions}
									/> */}

                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/category.png").default} className="img-fluid" />
                            </span>
                            <select id="subCategories" name="subCategories" className="field-des " form="subCategoriesForm" onChange={(event) => {
                                const value = event.target.value;
                                setSubCategoryId(value !== "All" ? value : null);
                                // if( value !== "All")
                                // {setQueryParam(`${queryparam}categoryId=${value}&`) };        

                            }}>
                                <option value="All">All sub categories</option>
                                {subCategoryOptions && subCategoryOptions.map((subCat, index) => <option key={index} value={subCat._id}>{subCat.name}</option>)}
                            </select>
                            {/* <Select id="color"
										value={option2}
										onChange={() => handleChange2()}
										classNamePrefix="ls-select-home"
										options={subCategoryOptions}
									/> */}
                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/pin.png").default} className="img-fluid" />
                            </span>
                            <PlacesAutocomplete value={address} onChange={setAddress} onSelect={handleSelect}>
                                {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                    <div className="city-location">
                                        <input {...getInputProps({ placeholder: "Type City" })} type="text" className="form-control field-des" />
                                        <div style={{ position: "relative" }}>
                                            <div style={{
                                                position: "absolute",
                                                zIndex: 1,
                                            }}>
                                                {loading ? <div>...Loading</div> : null}
                                                {suggestions.map((suggestion) => {
                                                    const style = {
                                                        backgroundColor: suggestion.active ? "#ff7e06" : "#fff",
                                                    };
                                                    return <div {...getSuggestionItemProps(suggestion, { style })}>{suggestion.description}</div>;
                                                })}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </PlacesAutocomplete>
                        </div>
                        <div className="form-group d-flex align-items-center custom-w applyPd">
                            <span className="input-group-addon">
                                <img alt="" src={require("../../../assets/images/arrows.png").default} className="img-fluid" />
                            </span>
                            <select id="distance" name="distance" className="field-des" form="distanceform" onChange={(event) => {
                                const value = event.target.value;
                                setDistance(value !== "null" ? value : null);
                                // setQueryParam(`${queryparam}distance=${value}&`)
                            }}>
                                {!geolocation.longitude && <option value="null" >Allow the location.</option>}
                                {!geolocation.error && lng && lat && <option value="null" >Select a distance</option>}
                                {!geolocation.error && lng && lat && <option value="10">10kms</option>}
                                {!geolocation.error && lng && lat && <option value="100">100kms </option>}
                                {!geolocation.error && lng && lat && <option value="500">500kms</option>}
                                {!geolocation.error && lng && lat && <option value="1000">1000kms</option>}
                                {!geolocation.error && lng && lat && <option value="5000">5000kms</option>}
                                {!geolocation.error && lng && lat && <option value="1500">1500kms</option>}
                                {!geolocation.error && lng && lat && <option value="2000">2000kms</option>}

                            </select>
                             {/* <Select id="color"
										value={option3}
										onChange={() => handleChange3()}
										classNamePrefix="ls-select-home"
										options={distanceOptions}
									/> */}

                        </div>
                        <div className="btn-wrapper custom-w">
                            <button type="button" className="btn btn-custom" onClick={() => {
                                const filters = {}
                                if (location)
                                    filters.location = location;
                                if (distance && !geolocation.error) {
                                    filters.distance = distance;
                                    filters.lng = lng;
                                    filters.lat = lat;
                                }
                                if (categoryId)
                                    filters.categoryId = categoryId;
                                if (subCategoryId)
                                    filters.subCategoryId = subCategoryId;
                                if (title)
                                    filters.title = title;

                                const queryParams = new URLSearchParams(filters);

                                history.push(
                                    { pathname: '/search-result', search: queryParams.toString(), state: { viaHome: true } })
                            }}>Search</button>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}

export default GoogleApiWrapper({
    apiKey: "AIzaSyBApvvMp-DolYwwyo3C2jpq6lGDpZzLeiU",
    libraries: ["places"],
})(SearchForm);